module.exports = __webpack_public_path__ + "img/logo.6172c07c.svg";